import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=70852aae&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=70852aae&prod&lang=css&scoped=true"
import style1 from "./Register.vue?vue&type=style&index=1&id=70852aae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70852aae",
  null
  
)

export default component.exports